module.exports = __webpack_public_path__ + "static/support-dc66d985eaff88cd42e59d124769ca1b.png";